import React, { useContext } from "react";
import OnPageBuilderContent from "./OnPageBuilderContent";
import { PageStaticDataContext } from "../../../../contexts/PageStaticDataContextProvider";

export type ProductBuilderProps = {};

const ProductBuilder = (props: ProductBuilderProps) => {
  const {
    locale,
    tabData,
    productBuilder,
    reviews,
    hideReviews,
    description,
    enableCampaignCallouts,
    productBuilderOptions,
    initialBuildState,
  } = useContext(PageStaticDataContext);

  return (
    <OnPageBuilderContent
      reviews={reviews}
      productBuilderSelections={productBuilderOptions?.selections || []}
      builderData={productBuilder}
      tabData={tabData}
      description={description}
      buildStateCtas={initialBuildState?.siteflow}
      hideReviews={hideReviews}
      showCampaignCallouts={enableCampaignCallouts}
      locale={locale}
    />
  );
};

export default ProductBuilder;
